import type { SupportedLanguage } from '@/lib/i18n'
import type { QuizPage } from './types'
import { quizPagesEn } from './quiz-content.en'
import { quizPagesZhTw } from './quiz-content.zh-TW'

export type { QuizPage, QuizOption, SocialProofConfig } from './types'

export function getQuizPages(lang: SupportedLanguage): QuizPage[] {
  return lang === 'zh-TW' ? quizPagesZhTw : quizPagesEn
}
